export const HELP_ACTIONS = {
  ASSISTANT: "ASSISTANT",
  SEND_EMAIL: "SEND_EMAIL",
  IMPROUVEMENT: "IMPROUVEMENT",
  OPEN_FAQ: "OPEN_FAQ",
  ISSUE_WITH_ETAB: "ISSUE_WITH_ETAB",
};
